import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { MatTableDataSource } from '@angular/material/table';
import { UFS, Municipio, MUNICIPIOS } from '../../shared/localizacao/municipios';
import { S3SrmPublicService } from '../../services/s3-srm-public.service';

@Component({
  selector: 'app-srm-municipio',
  templateUrl: './srm-municipio.component.html',
  styleUrls: ['./srm-municipio.component.css']
})
export class SrmMunicipioComponent implements OnInit {

  ufSelecionada: string | null = null;
  dataSelecionada: string | null = null;
  datas: string[] = [];
  // datas: string[] = ['01/2026', '12/2025', '11/2025', '10/2025', '09/2025'];

  displayedColumns: string[] = [
    'nome',
    'semSeca',
    's0s4',
    's1s4',
    's2s4',
    's3s4',
    's4'
  ];
 
  dataSource = new MatTableDataSource<Municipio>();
  ufs = UFS;
  // países (no momento apenas Brasil)
  paises = [{ nome: 'Brasil', sigla: 'BR', alias: 'brasil' }];
  loading = false;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private s3SrmPublicService: S3SrmPublicService
  ) {}

  navegarParaUf(uf: string) {
    this.router.navigate(['/srm/municipio', uf], {
      queryParams: this.currentQueryParams
    });
  }

  onDataChange(): void {
    this.router.navigate([], {
      relativeTo: this.route,
      queryParams: this.currentQueryParams,
      queryParamsHandling: 'merge'
    });
  }

  get currentQueryParams(): { data?: string } {
    return this.dataSelecionada ? { data: this.dataSelecionada } : {};
  }

  private applySelectedData(preferredData: string | null): void {
    if (preferredData && this.datas.includes(preferredData)) {
      this.dataSelecionada = preferredData;
      return;
    }

    this.dataSelecionada = this.datas[0] ?? null;
  }

  get imagemSrmUrl(): string | null {
    if (!this.ufSelecionada || !this.dataSelecionada) {
      return null;
    }

    // localizar UF ou País pelo código
    const uf = UFS.find(u => u.sigla === this.ufSelecionada) || this.paises.find(p => p.sigla === this.ufSelecionada);
    if (!uf) {
      return null;
    }

    /**
     * dataSelecionada no formato MM/YYYY
     * Ex: 10/2025 -> 202510
     */
    const [mes, ano] = this.dataSelecionada.split('/');
    if (!mes || !ano) {
      return null;
    }

    const anoMes = `${ano}${mes.padStart(2, '0')}`;

    return `https://ana-monitor-secas-files.s3.sa-east-1.amazonaws.com/uploads/produtos/srm_persist/${anoMes}/srm/srm_${uf.alias}_${anoMes}.png`;
  
  }

  get imagemMsUrl(): string | null {
    if (!this.ufSelecionada || !this.dataSelecionada) {
      return null;
    }

    // localizar UF ou País pelo código
    const uf = UFS.find(u => u.sigla === this.ufSelecionada) || this.paises.find(p => p.sigla === this.ufSelecionada);
    if (!uf) {
      return null;
    }

    /**
     * dataSelecionada no formato MM/YYYY
     * Ex: 10/2025 -> 202510
     */
    const [mes, ano] = this.dataSelecionada.split('/');
    if (!mes || !ano) {
      return null;
    }

    const anoMes = `${ano}${mes.padStart(2, '0')}`;

    if (this.ufSelecionada === 'BR') {
      const monthNames = [
        'janeiro', 'fevereiro', 'marco', 'abril', 'maio', 'junho',
        'julho', 'agosto', 'setembro', 'outubro', 'novembro', 'dezembro'
      ];
      const m = Number(mes);
      const y = Number(ano);
      if (Number.isInteger(m) && m >= 1 && m <= 12 && Number.isInteger(y)) {
        const BASE_YEAR = 2025;
        const BASE_MONTH = 10; // outubro
        const BASE_ID = 136; // id para outubro/2025
        const monthsDiff = (y - BASE_YEAR) * 12 + (m - BASE_MONTH);
        const id = BASE_ID + monthsDiff;
        const mêsNome = monthNames[m - 1];
        return `https://ana-monitor-secas-files.s3.sa-east-1.amazonaws.com/uploads/mapas/${id}_${mêsNome}${ano}.png`;
      }
    }

    return `https://ana-monitor-secas-files.s3.sa-east-1.amazonaws.com/uploads/produtos/srm_persist/${anoMes}/ms/ms_${uf.alias}_${anoMes}.png`;
  
  }
  
  async ngOnInit(): Promise<void> {
    this.loading = true;

    try {
      const months = await this.s3SrmPublicService.listAvailableMonths(); // ex: ['202602','202601','202512',...]
      console.log(`Meses, Itens encontrados:`, months);
      const datasS3 = months
        .filter(m => /^\d{6}$/.test(m))
        .map(m => `${m.slice(4)}/${m.slice(0, 4)}`);
      if (datasS3.length > 0) {
        this.datas = datasS3;
      }
    } catch (err) {
      console.error('Não foi possível listar meses S3:', err);
      // fallback: manter datas estáticas ou usar endpoint do servidor
    } finally {
      this.loading = false;
    }

    this.route.paramMap.subscribe(params => {
      const uf = params.get('uf');
      this.ufSelecionada = uf ? uf.toUpperCase() : null;

      if (!this.ufSelecionada) {
        this.dataSource.data = [];
        return;
      }

      const items = MUNICIPIOS.filter(m => m.uf === this.ufSelecionada);
      console.log(`UF: ${this.ufSelecionada}, Itens encontrados:`, items);
      this.dataSource.data = items ?? [];
    });

    this.route.queryParamMap.subscribe(queryParams => {
      this.applySelectedData(queryParams.get('data'));
    });

    if (!this.dataSelecionada && this.datas.length > 0) {
      this.applySelectedData(this.route.snapshot.queryParamMap.get('data'));
    }
  }
}
